/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import { Module, Node } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';

import { IPromoBannerViewProps } from './promo-banner';

const PromoBannerView: React.FC<IPromoBannerViewProps> = props => {
    const {
        promoBannerProps,
        contentProps,
        closeButton,
        bannerMessages,
        promoBannerTextProps,
        promoBannerLinksProps,
        carouselProps,
        promoBannerText,
        handleLinks,
        handleText
    } = props;

    const slides =
        bannerMessages &&
        bannerMessages.map((message, index) => {
            return (
                <Node {...contentProps} key={index} aria-live='off' role='marquee'>
                    <span className='sr-only'>{promoBannerText}</span>
                    {message.text && <Node {...promoBannerTextProps} text={message.text} onClick={handleText} />}
                    {message.links && message.links.length > 0 && (
                        <Node {...promoBannerLinksProps} links={message.links} onClick={handleLinks} />
                    )}
                </Node>
            );
        });

    return (
        <Module {...promoBannerProps}>
            <Node {...carouselProps} items={slides} />
            {closeButton}
        </Module>
    );
};
export default PromoBannerView;
